import React from "react";
import { Link, useLocation } from "react-router-dom";
import Divider from "@mui/material/Divider";
import Typography from "@mui/joy/Typography";

const Navbar = () => {
  const location = useLocation();

  return (
    <header
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 100,
        background: "rgba(255, 255, 255, 0.7)",
        backdropFilter: "blur(10px)",
        borderRadius: "30px",
        border: "1px solid #CDD7E1",
        padding: "10px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 4px 4px rgba(0,0,0,0.2)",
      }}
    >
      <nav>
        <ul
          style={{
            display: "flex",
            listStyle: "none",
            margin: 0,
            padding: 0,
            alignItems: "center",
          }}
        >
          <li
            style={{ margin: "0 12px", display: "flex", alignItems: "center" }}
          >
            <Link to="/" style={{ textDecoration: "none" }}>
              <Typography
                level="title-md"
                sx={{
                  fontWeight: location.pathname === "/" ? "bold" : "normal",
                }}
              >
                Home
              </Typography>
            </Link>
          </li>
          <Divider orientation="vertical" flexItem />
          <li
            style={{ margin: "0 12px", display: "flex", alignItems: "center" }}
          >
            <Link to="/portfolio" style={{ textDecoration: "none" }}>
              <Typography
                level="title-md"
                sx={{
                  fontWeight:
                    location.pathname === "/portfolio" ? "bold" : "normal",
                }}
              >
                Portfolio
              </Typography>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
